import React, { useState } from "react";
import { Pipette } from "lucide-react";
import { useToast } from "./ToastNotifications";

const EyeDropper = ({ onColorSelect }) => {
  const [isActive, setIsActive] = useState(false);
  const { addToast } = useToast();

  const handleClick = async () => {
    if (!window.EyeDropper) {
      addToast("Eye Dropper is not supported in this browser. Try Chrome or Edge.", "error");
      console.error("EyeDropper API is not supported in this browser");
      return;
    }

    setIsActive(true);
    const eyeDropper = new window.EyeDropper();
    try {
      const result = await eyeDropper.open();
      if (result && result.sRGBHex) {
        onColorSelect(result.sRGBHex);
        addToast(`Color picked: ${result.sRGBHex}`, "success");
      } else {
        addToast("Failed to pick color", "error");
      }
    } catch (error) {
      // User cancelled or error occurred
      if (error.name !== "AbortError") {
        console.error("EyeDropper error:", error);
        addToast("Failed to pick color. Try picking from the page content.", "error");
      }
    } finally {
      setIsActive(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`p-2 rounded-full transition-colors duration-200 hover:bg-gray-200 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${
        isActive ? "bg-gray-200 dark:bg-gray-700" : ""
      }`}
      disabled={isActive}
    >
      <Pipette className="h-5 w-5" />
    </button>
  );
};

export default EyeDropper;
